import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'

import API from '../api'

import { SubscriptionPolicy, SubsCrown } from 'pobble-components/dist/subscriptions'

@autobind
class WorkCommentForm extends Component {
  constructor (props) {
    super(props)
    this.state = {comment: '', posting: false}
  }

  handleCommentChange (event) {
    this.setState({comment: event.target.value})
  }

  onCommentSubmit (event) {
    event.preventDefault()
    this.setState({posting: true})
    API.post(`v3/works/${this.props.id}/comments?include=comment.details,comment.account,comment.account.names,comment.account.avatar,comment.timestamps,comment.geolocation.details`, { content: this.state.comment })
    .then(response => {
      this.props.onCommenting(response.data.comment)
      this.setState({comment: '', posting: false})
    })
  }

  redirectToSignIn () {
    window.location = '/auth'
  }

  render () {
    var avatar = <PobbleAvatar avatar={this.props.user.avatar} name={this.props.user.display_name} style={{fontSize: '40px'}} className='commentForm__user__avatar' />

    return (
      <form name='commentForm' className='commentForm' onSubmit={this.onCommentSubmit}>
        <div className='commentForm__box'>
          <textarea id='commentFormBody' placeholder='Type your comment here' value={this.state.comment} onChange={this.handleCommentChange} onClick={this.props.user.id ? this.props.hideCommentCta : this.redirectToSignIn} />
          <span className='commentForm__tail' />
        </div>
        <div className='commentForm__actions'>
          <div className='commentForm__user'>
            {avatar}
            <div>
              <strong className='commentForm__user__name'>{this.props.user && this.props.user.display_name}</strong>
              <span className='commentForm__user__desc'>That's you!</span>
            </div>
          </div>
          <SubscriptionPolicy policy={sp => sp.publish_work}>
            {publishingSp => publishingSp.restricted ? (
              <button className='btn btn-primary' type='button' onClick={ e => {  publishingSp.showDialog() && e.preventDefault()}}><SubsCrown accent /> Publish comment</button>

            ) : (
              <button className='btn btn-primary' type='submit' disabled={this.state.comment === '' || this.state.posting}>Publish comment</button>
            )}
          </SubscriptionPolicy>
        </div>
      </form>
    )
  }
}

WorkCommentForm.propTypes = {
  hideCommentCta: PropTypes.func,
  id: PropTypes.string,
  onCommenting: PropTypes.func,
  user: PropTypes.object
}

export default WorkCommentForm



// WEBPACK FOOTER //
// ./components/work/WorkCommentForm.js